import React from 'react';
import { Task } from '../../../types/workOrders';

interface TaskSelectorProps {
  selectedTask: string;
  tasks: Task[];
  loading: boolean;
  onChange: (task: string) => void;
}

export function TaskSelector({ selectedTask, tasks, loading, onChange }: TaskSelectorProps) {
  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
        Select Task
      </label>
      <select
        value={selectedTask}
        onChange={(e) => onChange(e.target.value)}
        className="w-full rounded-lg border border-light-border dark:border-dark-border bg-light-card dark:bg-dark-card text-gray-900 dark:text-gray-100 p-3"
        disabled={loading}
      >
        <option value="">Choose a task...</option>
        <option value="Unflagged photos">Unflagged photos</option>
        {tasks.filter(t => t.isVisible).map((task) => (
          <option key={task.id} value={task.desc}>
            {task.desc}
          </option>
        ))}
      </select>
    </div>
  );
}